import React, { useState } from 'react';
import { MarketingAPIQueuePushRequest } from '../../../interfaces/marketing';
import { marketingAPI } from '../../../api/marketing';

type Props = {
  className?: string;
};

const ProductBannerText: React.FC<Props> = ({ className }) => {
  const [inputEmail, setInputEmail] = useState('');
  return (
    <>
      <div
        className={`text-left lg:col-start-1 lg:col-span-3 xl:items-center lg:mt-14  xl:mt-16 2xl:mt-32 ${className}`}
      >
        <h2 className="text-3xl tracking-tight font-bold  sm:text-3xl md:text-5xl">
          <div className={'row'}>
            {/* <span className="block inline text-primary-600">All-in-One</span> */}
            {/*<span className="block inline text-gray-900">Mobile </span>*/}
          </div>

          <span className="block text-gray-900">
            All-In-One Contactless Mobile Ordering Solution
          </span>
        </h2>
        <p className="px-0 mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
          Digital menus, dynamic QR codes, and mobile order & payment, all
          managed from a single dashboard.
        </p>
        <div className="mt-5 sm:mt-8 sm:flex justify-start">
          {/*<div className="rounded-full shadow ">*/}
          {/*  <a*/}
          {/*    href="/contact"*/}
          {/*    className="w-full flex items-center justify-center px-4 py-1 border border-transparent text-base font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 md:py-1 md:text-md md:px-4 hover:text-white"*/}
          {/*  >*/}
          {/*    Get Started*/}
          {/*  </a>*/}
          {/*</div>*/}
          <form
            className="mt-5 sm:flex sm:items-center w-full"
            id={'product_hero_form'}
            onSubmit={async e => {
              e.preventDefault();
              // @ts-ignore
              window.analytics.identify({
                email: inputEmail,
              });
              const pushToQ: MarketingAPIQueuePushRequest = {
                email: inputEmail,
              };
              const response = await marketingAPI.pushEmailToQueue(pushToQ);
              window.open(
                'https://portal.tabletab.io/signup?ref=product_hero_form',
              );
            }}
          >
            <div className="max-w-xs w-full">
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                required
                onChange={e => {
                  setInputEmail(e.target.value);
                }}
                className="shadow-sm focus:ring-primary-600 focus:border-primary-600 text-base block w-full border-gray-300 rounded-full"
                placeholder="Enter your email"
              />
            </div>
            <button
              type="submit"
              className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-full text-base text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-600 sm:mt-0 sm:ml-3 sm:w-1/3 lg:w-2/3 md:w-1/2"
            >
              Get Started
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ProductBannerText;
